import type { ReactNode } from 'react';
import Observer from '@researchgate/react-intersection-observer';

type Props = {
  id: string;
  onIntersection?: (id: string) => void;
  children: ReactNode;
};

export const ImpressionTracking = ({ children, id, onIntersection }: Props) => (
  <Observer
    threshold={1}
    onChange={({ isIntersecting }) => {
      if (isIntersecting && onIntersection) {
        onIntersection(id);
      }
    }}
  >
    <div>{children}</div>
  </Observer>
);
